/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * User ID
     * @type {string}
     * @memberof UserDto
     */
    id: string;
    /**
     * User email
     * @type {string}
     * @memberof UserDto
     */
    email: string;
    /**
     * User display name
     * @type {string}
     * @memberof UserDto
     */
    displayName: string;
    /**
     * User first name
     * @type {string}
     * @memberof UserDto
     */
    firstName: string;
    /**
     * User last name
     * @type {string}
     * @memberof UserDto
     */
    lastName: string;
    /**
     * User photo URL
     * @type {string}
     * @memberof UserDto
     */
    photoUrl: string;
    /**
     * User type
     * @type {string}
     * @memberof UserDto
     */
    userType: string;
}

/**
 * Check if a given object implements the UserDto interface.
 */
export function instanceOfUserDto(value: object): value is UserDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('photoUrl' in value) || value['photoUrl'] === undefined) return false;
    if (!('userType' in value) || value['userType'] === undefined) return false;
    return true;
}

export function UserDtoFromJSON(json: any): UserDto {
    return UserDtoFromJSONTyped(json, false);
}

export function UserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'displayName': json['displayName'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'photoUrl': json['photoUrl'],
        'userType': json['userType'],
    };
}

export function UserDtoToJSON(json: any): UserDto {
    return UserDtoToJSONTyped(json, false);
}

export function UserDtoToJSONTyped(value?: UserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'displayName': value['displayName'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'photoUrl': value['photoUrl'],
        'userType': value['userType'],
    };
}

